import { useLazyQuery } from "@apollo/client";
import React, { useEffect, useRef, useState, useMemo } from "react";
import { NotificationManager } from "react-notifications";
import InviteUsersGroupsComponent from "../../components/InviteUsersGroupsComponent/InviteUsersGroupsComponent";
import {
  ALL_ROLES_BY_LEVEL,
  COUNTRIES_BY_CLIENT,
  USERS_ADVANCE_SEARCH,
  USERS_BY_IDS,
  USERS_IN_ROLE2,
  ALL_LOBS_COUNTRY,
} from "../../GraphQL/Queries";
import { getStateLoginComplete } from "../LayoutHome/stateLogin";
import PropTypes from "prop-types";
import { ROLES } from "../../util/RolesConstants";
import { messages } from "../../util/message";

const InviteUsersGroupsContainer = ({
  editData,
  action,
  usersSelected,
  setUsersSelected,
  groupsSelected,
  setGroupsSelected,
  columnDisplay,
  fieldLabel,
  groupAssignLabel,
  mandatory,
  showIconFieldLabel,
  disabledSelector,
  userDeleted,
  setUserDeleted,
  groupDeleted,
  setGroupDeleted,
}) => {
  const rCountries = useRef();
  const rCities = useRef();
  const rRoles = useRef();
  const rLobs = useRef();
  const rSelectedUsers = useRef();
  const rComoNonComo = useRef();
  const user = useMemo(() => getStateLoginComplete(), []);
  const clientId = useMemo(() => user.clientId, []);
  const [usersAdvanceSearch, setUsersAdvanceSearch] = useState([]);
  const [showAdvanceOption, setShowAdvanceOption] = useState(false);
  const [selectedCountry, setSelectedCountry] = useState();
  const [selectedComoNonComo, setSelectedComoNonComo] = useState(null);
  const [selectedCity, setSelectedCity] = useState();
  const [selectedRole, setSelectedRole] = useState();
  const [selectedLob, setSelectedLob] = useState();
  const [selectedUsers, setSelectedUsers] = useState([]);
  const [allCountries, setAllCountries] = useState([]);
  const [allCities, setAllCities] = useState([]);
  const [individualGuests, setIndividualGuests] = useState([]);
  const [allRolesByLevel, setAllRolesByLevel] = useState([]);
  const [allLobs, setAllLobs] = useState([]);
  const [groups, setGroups] = useState([]);
  const [guestsData, setGuestsData] = useState([]);

  const [runQueryLobsByCountry] = useLazyQuery(ALL_LOBS_COUNTRY, {
    fetchPolicy: "network-only",
    onCompleted: (data) => {
      let resultOfAllLobs = data.lobsListByCountry.map((element) => {
        return {
          value: element?.lobId,
          label: element?.lobName,
        };
      });
      setAllLobs(resultOfAllLobs);
    },
  });

  const [runQueryUsersByIds] = useLazyQuery(USERS_BY_IDS, {
    fetchPolicy: "network-only",
    onCompleted: (data) => {
      let usersByIds = data.userAdminlistByIds.map((element) => {
        let userFullName = element?.userFirstName + " " + element?.userLastName;
        return {
          value: element?.userId,
          label: userFullName + " " + element?.userCcms,
          firstName: element?.userFirstName,
          lastName: element?.userLastName,
          emailAddress: element?.userEmailAddress,
          ccmsuser: element?.ccmsuser,
          ccmsid: element?.userCcms,
          userStatus: element?.enabled,
        };
      });

      setIndividualGuests(usersByIds);
    },
  });

  const [runQueryUsersAdvanceSearch] = useLazyQuery(USERS_ADVANCE_SEARCH, {
    fetchPolicy: "network-only",
    onCompleted: (data) => {
      let resultOfUsersAdvanceSearch = data.userListAdvancedSearch.map(
        (element) => {
          return element;
        }
      );
      setUsersAdvanceSearch(resultOfUsersAdvanceSearch);
    },
  });

  const [runQueryCountry] = useLazyQuery(COUNTRIES_BY_CLIENT, {
    fetchPolicy: "network-only",
    onCompleted: (data) => {
      let resultOfAllCountries = data.countryLocationList.map((element) => {
        return {
          ...element,
          value: element?.countryId,
          label: element?.countryName,
        };
      });
      setAllCountries(resultOfAllCountries);
    },
  });

  const [
    runQueryRolesByLevel,
    { error: errorRoleByLevel, loading: loadingRoleByLevel },
  ] = useLazyQuery(ALL_ROLES_BY_LEVEL, {
    fetchPolicy: "network-only",
    onCompleted: (data) => {
      if (fieldLabel === "Approve users") {
        let resultOfAllRolesByLevel = data.rolesByUserProfile.filter((f) => f.roleId !== ROLES.AGENT).map((element) => {
          return {
            value: element?.roleId,
            label: element?.friendlyDescription,
            roleLevel: element?.roleLevel,
          };
        });
        setAllRolesByLevel(resultOfAllRolesByLevel);
      } else {
        let resultOfAllRolesByLevel = data.rolesByUserProfile.map((element) => {
          return {
            value: element?.roleId,
            label: element?.friendlyDescription,
            roleLevel: element?.roleLevel,
          };
        });
        setAllRolesByLevel(resultOfAllRolesByLevel);
      }
    },
  });

  const [
    runQueryUsersInRole2,
    { error: errorUsersInRole, loading: loadingUsersInRole },
  ] = useLazyQuery(USERS_IN_ROLE2, {
    fetchPolicy: "network-only",
    onCompleted: (data) => {
      let usersInRole2 = data.userListAdvancedSearch.map((element) => {
        return {
          value: element?.userId,
          label:
            element?.userFirstName +
            " " +
            element?.userLastName +
            " " +
            element?.userCcms,
          firstName: element?.userFirstName,
          lastName: element?.userLastName,
          emailAddress: element?.userTpId,
          ccmsid: element?.userCcms,
          ccmsuser: element?.userCcms,
        };
      });
      setGuestsData(usersInRole2);
    },
  });

  const handleChangeComoNoComo = (item) => {
    if (item.value === 1) {
      setSelectedComoNonComo(true);
    } else if (item.value === 2) {
      setSelectedComoNonComo(false);
    }
    else {
      setSelectedComoNonComo(null)
    }
  };

  useEffect(() => {
    let rolesId = allRolesByLevel.map((element) => {
      return element.value;
    });

    if (user.roleId && rolesId.length > 0) {
      runQueryUsersInRole2({
        variables: { rolesId: rolesId },
        context: { clientName: "LinkUsers" },
      });
    }
  }, [allRolesByLevel]);

  useEffect(() => {
    if (editData && action === "edit") {
      setIndividualGuests(editData.guests);
      setGroups(editData.groups);
    }
  }, [editData, action]);

  useEffect(() => {
    if (clientId) {
      runQueryCountry({
        variables: { clientId: clientId },
        context: { clientName: "LinkUsers" },
      });
    }

    if (user.roleId) {
      runQueryRolesByLevel({
        variables: { roleId: user.roleId },
        context: { clientName: "LinkUsers" },
      });
    }
  }, [clientId, user]);

  useEffect(() => {
    if (selectedUsers.length > 0) {
      let selected = selectedUsers.map((element) => {
        return element.value;
      });

      handleUsersByIds([...selected]);
    } else {
      setIndividualGuests([]);
    }
  }, [selectedUsers]);

  useEffect(() => {
    if (selectedUsers.length) {
      let selection = selectedUsers;
      individualGuests.forEach((element) => {
        if (selection.findIndex((f) => f.label === element.label) === -1) {
          selection.push(element);
        }
      });

      setIndividualGuests(selection);
    } else {
      setIndividualGuests(selectedUsers);
    }
  }, [selectedUsers]);

  useEffect(() => {
    if (groupsSelected && groupsSelected.length > 0) {
      setGroups([...groupsSelected]);
    }
    if (groupsSelected && groupsSelected.length === 0) setGroups([]);
  }, [groupsSelected]);

  useEffect(() => {
    if (usersSelected && usersSelected.length > 0) {
      setSelectedUsers([...usersSelected]);
    }
    if (usersSelected && usersSelected.length === 0) setSelectedUsers([]);
  }, [usersSelected]);

  useEffect(() => {
    handleUsersAdvanceSearch();
  }, [
    clientId,
    selectedCountry?.countryIds,
    selectedCity?.cityIds,
    selectedRole?.roleIds,
    selectedLob?.lobIds,
    selectedComoNonComo,
  ]);

  const handleUsersByIds = (usersIds) => {
    runQueryUsersByIds({
      variables: { usersIds: usersIds },
      context: { clientName: "LinkUsers" },
    });
  };

  const handleUsersAdvanceSearch = () => {
    if (selectedComoNonComo !== null) {
      runQueryUsersAdvanceSearch({
        variables: {
          clientId: clientId,
          countries: selectedCountry?.countryIds,
          cities: selectedCity?.cityIds,
          roles: selectedRole?.roleIds,
          lobs: selectedLob?.lobIds,
          isCoMoUser: selectedComoNonComo,
        },
        context: { clientName: "LinkUsers" },
      });
    } else {
      runQueryUsersAdvanceSearch({
        variables: {
          clientId: clientId,
          countries: selectedCountry?.countryIds,
          cities: selectedCity?.cityIds,
          roles: selectedRole?.roleIds,
          lobs: selectedLob?.lobIds,
        },
        context: { clientName: "LinkUsers" },
      });
    }
  };

  const cleanSelects = () => {
    setSelectedCountry();
    setSelectedCity();
    setSelectedRole();
    setSelectedLob();
    setUsersAdvanceSearch([]);
    setAllCities([]);
    setTimeout(() => {
      setShowAdvanceOption(true);
    }, 0);
  };

  const closeAdvanceSearch = () => {
    setShowAdvanceOption(false);
  };

  const handleChangeSelectCountry = (item) => {
    setSelectedCountry({
      country: item,
      countryIds: item.value,
    });
    if (item.value) {
      handleCities(item.value);
    } else {
      setAllCities([]);
    }
    rCities.current.state.ariaSelection = [];
    setSelectedCity();
  };

  const getCityForCountry = (id) => {
    let selectedCountry = allCountries.filter(
      (e) => e.countryId === parseInt(id)
    );
    if (selectedCountry?.length > 0) {
      let citiesArr = selectedCountry[0].cities.map((e) => {
        return {
          ...e,
          value: e.cityId,
          label: e.cityName,
        };
      });
      setAllCities(citiesArr);
    } else {
      setAllCities([]);
    }
  };

  const handleCities = (countryId) => {
    getCityForCountry(countryId);
    runQueryLobsByCountry({
      variables: { countryId: countryId, searchBy: "" },
      context: { clientName: "LinkUsers" },
    });
    if (rCities && rCities.current) rCities.current.clearValue();
  };

  const handleChangeSelectCity = (items) => {
    let selectedItems = items.map((element) => {
      return element.value;
    });
    setSelectedCity({
      cities: items,
      cityIds: selectedItems,
    });
  };

  const handleChangeSelectUsers = (items) => {
    if (items.length > 0) {
      const selection = [...individualGuests];
      items.forEach((element) => {
        if (selection.findIndex((f) => f.value === element.value) === -1) {
          selection.push(element);
        }
      });

      setIndividualGuests(selection);
      setUsersSelected(selection);
    } else {
      setIndividualGuests([]);
      setUsersSelected([]);
    }
  };

  const handleChangeSelectRole = (items) => {
    let selectedItems = items.map((element) => {
      return element.value;
    });
    setSelectedRole({
      roles: items,
      roleIds: selectedItems,
    });
  };

  const handleChangeSelectLob = (items) => {
    let selectedItems = items.map((element) => {
      return element.value;
    });
    setSelectedLob({
      lobs: items,
      lobIds: selectedItems,
    });
  };

  const createGroup = () => {
    const parts = [
      selectedCountry?.country.label,
      ...(selectedCity?.cities ?? []).map((item) => item.label),
      ...(selectedRole?.roles ?? []).map((item) => item.label),
      ...(selectedLob?.lobs ?? []).map((item) => item.label),
    ].filter(Boolean);
    const groupName = parts.join(" ").trim();

    if (groupName !== "") {
      if (usersAdvanceSearch.length === 0) {
        NotificationManager.warning(messages.GroupNoMembers, "", 5000);
        return;
      }
      groups.push({
        groupName: groupName,
        userIds: usersAdvanceSearch.map((e) => e.userId),
      });
      setGroupsSelected(groups);
      closeAdvanceSearch();
    }
  };

  const removeUserAsigned = (index, item) => {
    const dto = [...individualGuests];
    dto.splice(index, 1);
    setIndividualGuests(dto);
    setUsersSelected(dto);
    if (setUserDeleted) {
      setUserDeleted([...userDeleted, item.value]);
    }
  };

  const removeGroupsAsigned = (index, item) => {
    const dto = [...groups];
    dto.splice(index, 1);
    setGroups(dto);
    setGroupsSelected(dto);
    if (groupDeleted) {
      setGroupDeleted([...groupDeleted, item.value]);
    }
  };

  return (
    <InviteUsersGroupsComponent
      showAdvanceOption={showAdvanceOption}
      selectedUsers={selectedUsers}
      closeAdvanceSearch={closeAdvanceSearch}
      allCountries={allCountries}
      handleChangeSelectCountry={handleChangeSelectCountry}
      rCountries={rCountries}
      rCities={rCities}
      rRoles={rRoles}
      rLobs={rLobs}
      allCities={allCities}
      handleChangeSelectCity={handleChangeSelectCity}
      loadingRoleByLevel={loadingRoleByLevel}
      errorRoleByLevel={errorRoleByLevel}
      allRolesByLevel={allRolesByLevel}
      handleChangeSelectRole={handleChangeSelectRole}
      setSelectedRole={setSelectedRole}
      allLobs={allLobs}
      handleChangeSelectLob={handleChangeSelectLob}
      usersAdvanceSearch={usersAdvanceSearch}
      createGroup={createGroup}
      rSelectedUsers={rSelectedUsers}
      guestsData={guestsData}
      handleChangeSelectUsers={handleChangeSelectUsers}
      cleanSelects={cleanSelects}
      individualGuests={individualGuests}
      loadingUsersInRole={loadingUsersInRole}
      errorUsersInRole={errorUsersInRole}
      removeUserAsigned={removeUserAsigned}
      groups={groups}
      removeGroupsAsigned={removeGroupsAsigned}
      columnDisplay={columnDisplay}
      fieldLabel={fieldLabel}
      groupAssignLabel={groupAssignLabel}
      mandatory={mandatory}
      showIconFieldLabel={showIconFieldLabel}
      disabledSelector={disabledSelector}
      handleChangeComoNoComo={handleChangeComoNoComo}
      rComoNonComo={rComoNonComo}
    />
  );
};

InviteUsersGroupsContainer.propTypes = {
  editData: PropTypes.array,
  action: PropTypes.string,
  usersSelected: PropTypes.array,
  setUsersSelected: PropTypes.func,
  groupsSelected: PropTypes.array,
  setGroupsSelected: PropTypes.func,
  columnDisplay: PropTypes.bool,
  fieldLabel: PropTypes.string,
  groupAssignLabel: PropTypes.string,
  mandatory: PropTypes.bool,
  showIconFieldLabel: PropTypes.bool,
  disabledSelector: PropTypes.bool,
  userDeleted: PropTypes.array,
  setUserDeleted: PropTypes.func,
  groupDeleted: PropTypes.array,
  setGroupDeleted: PropTypes.func,
}

export default InviteUsersGroupsContainer;
